import { AppShellContent, Group, Stack, Text, Title } from "@assetwatch/ui";

export function HomeScreen() {
  return (
    <AppShellContent>
      <Stack gap={24}>
        <Group justify="between" wrap="wrap">
          <Stack gap={8}>
            <Title size="lg">Work</Title>
            <Text tone="subtle">
              Frontend workspace generated from the AssetWatch app work.
            </Text>
          </Stack>
        </Group>
      </Stack>
    </AppShellContent>
  );
}
